export default __webpack_public_path__ + "static/media/gallery_03.69066d7e.jpg";